const features = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '独创向下滑动的流畅阅读体验，无需翻页即可连贯浏览完整章节，滚动条漫一气呵成，阅读节奏由你掌控。',
    color: 'text-primary-500 bg-primary-100',
  },
  {
    icon: 'ri-smartphone-line',
    title: '竖屏完美适配',
    desc: '专为手机竖屏使用场景深度优化，条漫画面自适应屏幕宽度，无论iOS还是Android都能享受最佳视觉体验。',
    color: 'text-accent-500 bg-accent-100',
  },
  {
    icon: 'ri-global-line',
    title: '日漫韩漫国漫全覆盖',
    desc: '精心收录日本漫画、韩国条漫和国漫精品，涵盖恋爱甜宠、热血战斗、奇幻冒险、悬疑推理等全品类题材。',
    color: 'text-secondary-600 bg-secondary-100',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质呈现',
    desc: '所有漫画采用高分辨率图片加载，保证画面细节清晰锐利，暗部层次分明，线条锐度出色，沉浸式阅读不打折扣。',
    color: 'text-primary-500 bg-primary-100',
  },
  {
    icon: 'ri-vip-crown-line',
    title: '全站免费畅读',
    desc: '坚持免费阅读原则，无需订阅付费会员，所有连载漫画和完结作品均可免费畅读，让每位漫画爱好者无负担追更。',
    color: 'text-accent-500 bg-accent-100',
  },
];

export default function Features() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-xl md:text-3xl text-foreground-950 mb-3">
            阅读特色
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            为什么越来越多的漫画爱好者选择酷漫屋？五大核心体验给你答案
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-background-100 rounded-lg p-5 md:p-6 flex flex-col items-center text-center group hover:bg-background-200/80 transition-colors"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full ${f.color} mb-4`}>
                <i className={`${f.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg text-foreground-950 mb-2 whitespace-nowrap">
                {f.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}